import { Text, StyleSheet } from "react-native";
import { appColors } from "../constants/colors";

export default function ResultInput({ value }) {
  return <Text style={styles.resultText}>{value}</Text>;
}

const styles = StyleSheet.create({
  resultText: {
    backgroundColor: appColors.inputBg,
    borderRadius: 8,
    paddingVertical: 5,
    paddingHorizontal: 10,
    fontSize: 12,
    fontWeight: "500",
    color: appColors.primary,
    textAlign: "right",
  },
});
